import { IRecording } from '../../appointments/recording/RecordingState';

export const AITranscription: React.FC<{ recording: IRecording; }> = ({ recording }) => {
    return recording?.transcription && (
        <div>{recording.transcription}</div>
    );
};
